import { format, parse } from "date-fns";
import { store } from "../_app";
import { resetDashboard } from "../_features/dashboard";
import { resetEmployee, resetMessages, resetUser } from "../_features";
import { resetPayroll } from "../_features/payroll";
import moment from "moment";
import { Notify } from "./toastPopup";
import { Constant } from "../config";
import XLSX from "xlsx";
import { Parser } from "expr-eval-fork";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

const MONTH_FULL_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/** Array for Options of month */
const MONTH_OPTIONS = [
  {
    key: "January",
    value: "1",
  },
  {
    key: "February",
    value: "2",
  },
  {
    key: "March",
    value: "3",
  },
  {
    key: "April",
    value: "4",
  },
  {
    key: "May",
    value: "5",
  },
  {
    key: "June",
    value: "6",
  },
  {
    key: "July",
    value: "7",
  },
  {
    key: "August",
    value: "8",
  },
  {
    key: "September",
    value: "9",
  },
  {
    key: "October",
    value: "10",
  },
  {
    key: "November",
    value: "11",
  },
  {
    key: "December",
    value: "12",
  },
];

const resetStoreData = async () => {
  // return store.getState().user.access;
  store.dispatch(resetDashboard());
  store.dispatch(resetEmployee());
  store.dispatch(resetMessages());
  store.dispatch(resetPayroll());
  store.dispatch(resetUser());
};
const getFormatedDate = (date?: string) => {
  const d = date ? new Date(date) : new Date();

  const day = d.getDate();
  const m = MONTHS[d.getMonth()];
  const y = d.getFullYear();
  return `${day} ${m} ${y}`;
};

const formateNumber = (_: any) => {
  const val = _;
  return val > 9 ? val : `0${val}`;
};
const getDate = () => {
  const d = new Date();
  const lastData = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  return `${d.getFullYear()}-${formateNumber(
    d.getMonth() + 1
  )}-${lastData.getDate()}`;
};

const _date = (date?: string | Date) => {
  const d = date ? new Date(date) : new Date();

  const day = formateNumber(d.getDate());
  const m = formateNumber(d.getMonth() + 1);
  const y = d.getFullYear();
  return `${y}-${m}-${day}`;
};

const _dateToShow = (date?: string | Date) => {
  const d = date ? new Date(date) : new Date();

  const day = formateNumber(d.getDate());
  const m = formateNumber(d.getMonth() + 1);
  const y = d.getFullYear();
  return `${day}-${m}-${y}`;
};

const _timeToShow = (time?: string | Date) => {
  const t = time ? new Date(time) : new Date();
  return t.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

const validateEmail = (email: string) => {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email
  );
};

const getEmployeeName = (
  type: string,
  firstName: string,
  lastName?: string
) => {
  if (type === "First Name Last Name") {
    return `${firstName}, ${lastName}`;
  } else if (type === "Last Name First Name") {
    return `${lastName}, ${firstName}`;
  } else {
    return `${firstName}`;
  }
};

const getNumberWithCommas = (x: number | string) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const getPriceFromString = (amount: string | undefined) => {
  if (amount === "" || amount === undefined) {
    return "";
  }
  return amount.replace(/[, %]/g, "");
};

const isNumberWithComma = (number: string | undefined) => {
  const val = getPriceFromString(number);

  return val.match(/^-?\d+$/) ? true : val.match(/^\d+\.\d+$/) ? true : false;
};

const sortString = (str: string) => {
  return str.split("").sort().join("") || "";
};

const convertToDateString = (dateString: string) => {
  const date = new Date(dateString);
  const formattedDate = format(date, "d MMMM yyyy");
  return formattedDate;
};

const differenceInDays = (date1: string, date2: string) => {
  const date1Formatted = new Date(date1);
  const date2Formatted = new Date(date2);

  var date1_ms = date1Formatted.getTime();
  var date2_ms = date2Formatted.getTime();

  // Calculate the difference in milliseconds
  var difference_ms = Math.abs(date2_ms - date1_ms);

  // Convert the difference back into days
  return Math.floor(difference_ms / (1000 * 60 * 60 * 24));
};

const differenceInMonths = (date1: Date, date2: Date) => {
  const d1Year = date1.getFullYear();
  const d2Year = date2.getFullYear();
  const d1Month = date1.getMonth();
  const d2Month = date2.getMonth();

  return (d1Year - d2Year) * 12 + (d1Month - d2Month);
};

const monthsPassed = (
  referenceSring: string,
  dateString: string
): { count: number; monthYear: string } => {
  const refDate = parse(referenceSring, "yyyy-MM-dd", new Date());
  const date = parse(dateString, "yyyy-MM-dd", new Date());
  const count = differenceInMonths(refDate, date) - 1;
  const monthYear = format(date, "MMMM yyyy");
  return { count, monthYear };
};

const isEmpty = (val: any) => {
  if (val === "" || val === undefined || val === null) {
    return true;
  }
  if (typeof val === "string" && val?.trim() === "") {
    return true;
  }
  return false;
};

const formateStringWithUnderscore = (string: string) => {
  if (isEmpty(string)) {
    return "";
  }
  let str = string.replaceAll("_", " ");
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const getDefaultYearRange = (year: number = moment().year()) => {
  const startYear = Math.max(year - 3, 2024);
  const yearsRange = Array.from({ length: 10 }, (_, i) => startYear + i);

  console.log("yearRange", yearsRange);
  return yearsRange;
};

const generateYearArray = (startYear: number) => {
  const currentYear = new Date().getFullYear();
  const yearArray = [];

  for (let year = startYear; year < currentYear; year++) {
    yearArray.push(year);
  }

  return yearArray;
};

const generateYearArrayTillNow = (startYear: number) => {
  const currentYear = new Date().getFullYear();
  const yearArray = [];

  for (let year = startYear; year <= currentYear; year++) {
    yearArray.push(year);
  }

  return yearArray;
};

const monthNameNumberMap: { [key: string]: number } = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

const prependDollar = (num: any) => {
  return "$" + num;
};

const getLastDayOfMonth = (year: any, month: any) => {
  const date = new Date(year, month, 1);
  date.setDate(0);

  const lastDayFormatted = _date(date);

  return lastDayFormatted;
};

const addDecimalAndZeroes = (numberString: string) => {
  // Check if the number string contains a decimal point
  if (!numberString.includes(".")) {
    // If it doesn't, add ".00" and return the updated string
    return numberString + ".00";
  } else {
    // If it already has a decimal point, return the original string
    return numberString;
  }
};

const getPreviousMonthYear = (dateString: string) => {
  const d = new Date(dateString);
  d.setDate(1);
  d.setHours(-1);
  const previousYear = d.getFullYear();
  const previousMonth = d.getMonth() + 1; // Adding 1 since months are zero-based

  return { previousYear, previousMonth };
};

const getNextMonthYear = (dateString: string) => {
  const d = new Date(dateString);
  d.setDate(1);
  d.setMonth(d.getMonth() + 1);
  const nextYear = d.getFullYear();
  const nextMonth = d.getMonth() + 1; // Adding 1 since months are zero-based

  return { nextYear, nextMonth };
};

const getMonthRange = (monthStr: string) => {
  const parts = monthStr.split(" ");
  const year = parseInt(parts[1]);
  const monthIndex = MONTH_FULL_NAMES.indexOf(parts[0]);

  const firstDay = new Date(year, monthIndex, 1);
  const lastDay = new Date(year, monthIndex + 1, 0);

  return `${moment(firstDay).format("DD-MM-YYYY")} to ${moment(lastDay).format("DD-MM-YYYY")}`;
};

const dayMonthNameFormat = (inputDate: string) => {
  const months = MONTH_FULL_NAMES;

  const [year, month, day] = inputDate.split("-");
  const monthIndex = parseInt(month, 10) - 1;
  const formattedDate = `${day} ${months[monthIndex]} ${year}`;
  return formattedDate;
};

const removeDuplicates = (array: any, property: any) => {
  const uniqueValues: any = {};
  const result: any = [];

  for (const obj of array) {
    const value = obj[property];

    if (!uniqueValues[value]) {
      // If the value is not encountered yet, add it to the result array
      result.push(obj);
      uniqueValues[value] = true;
    }
  }

  return result;
};

const getCommanSepartedNumericStringWithDollar = (
  num: string | number
): string => {
  if (typeof num === "string") {
    // num = parseFloat(num);
    num = parseFloat(num.replace(/[$,]/g, ""));
  }
  if (
    isNaN(num) ||
    typeof num === "undefined" ||
    num === null ||
    !isFinite(num)
  ) {
    // return '$0.00';
    return "";
  } else {
    return "$" + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};
const getCommanSepartedNumericString = (num: string | number): string => {
  if (typeof num === "string") {
    // num = parseFloat(num);
    num = parseFloat(num.replace(/[$,]/g, ""));
  }
  if (
    isNaN(num) ||
    typeof num === "undefined" ||
    num === null ||
    !isFinite(num)
  ) {
    // return '$0.00';
    return "";
  } else {
    return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

function formatTimestamp(timestamp: string): string {
  const date = new Date(timestamp);
  const now = new Date();
  const diff = now.getTime() - date.getTime();

  // Convert milliseconds to seconds
  const seconds = Math.floor(diff / 1000);

  // Convert seconds to minutes
  const minutes = Math.floor(seconds / 60);

  // Convert minutes to hours
  const hours = Math.floor(minutes / 60);

  // Convert hours to days
  const days = Math.floor(hours / 24);

  if (days > 1) {
    return `${days} days ago`;
  } else if (hours > 1) {
    return `${hours} hours ago`;
  } else if (minutes > 1) {
    return `${minutes} minutes ago`;
  } else {
    return `less than a minute ago`;
  }
}

function getStartDateOfMonth(year: string, month: string) {
  return moment(`${year}-${month}-01`).startOf("month").format("YYYY-MM-DD");
}

function getLastDateOfMonth(year: string, month: string) {
  return moment(`${year}-${month}-01`).endOf("month").format("YYYY-MM-DD");
}

const validateNetPay = (netPay: any) => {
  if (
    !Number.isNaN(parseFloat(Utils.getPriceFromString(netPay))) &&
    parseFloat(Utils.getPriceFromString(netPay)) >= 0
  ) {
    return true;
  }
};
const showErrorMessage = (error: any) => {
  console.error("errorRes", error);
  // Handle different error types
  if (error?.response?.data?.message) {
    // API error with specific message
    Notify(error.response.data.message, 0);
  } else if (error?.response?.data?.error) {
    // API error with error field
    Notify(error.response.data.error, 0);
  } else if (error?.response?.data) {
    let errors = Object.values(error.response.data);
    if (Array.isArray(errors) && errors.length > 0) {
      // If the error response contains an array of errors
      Notify(errors.join(", "), 0);
    } else {
      // Fallback for other error structures
      Notify(Constant.common.something_went_wrong, 0);
    }
  } else if (error?.message) {
    // Standard Error object
    Notify(error.message, 0);
  } else if (typeof error === "string") {
    // String error
    Notify(error, 0);
  } else {
    // Fallback for unknown error types
    Notify(Constant.common.something_went_wrong, 0);
  }
};

const getLastDayOfPreviousMonth = (date: string) => {
  const givenDate = moment(date);
  const lastDateOfPreviousMonth = givenDate
    .clone()
    .subtract(1, "months")
    .endOf("month")
    .format("YYYY-MM-DD");
  return lastDateOfPreviousMonth;
};

const getFirstDayOfPreviousMonth = (date: string) => {
  const givenDate = moment(date);
  const firstDateOfPreviousMonth = givenDate
    .clone()
    .subtract(1, "months")
    .startOf("month")
    .format("YYYY-MM-DD");
  return firstDateOfPreviousMonth;
};

const getFirstDayOfTheMonth = (date: string) => {
  const givenDate = moment(date);
  const firstDateOfMonth = givenDate
    .clone()
    .startOf("month")
    .format("YYYY-MM-DD");
  return firstDateOfMonth;
};

const getLastDayOfTheMonth = (date: string) => {
  const givenDate = moment(date);
  const lastDateOfMonth = givenDate
    .clone()
    .endOf("month")
    .format("YYYY-MM-DD");
  return lastDateOfMonth;
};

const getMonthNameWithYear = (date: string) => {
  const givenDate = moment(date);
  const firstDateOfPreviousMonth = givenDate.clone().format("MMMM YYYY");
  return firstDateOfPreviousMonth;
};

// worksheet parameter expects the result of XLSX.utils.aoa_to_sheet(combinedData)
const autoFitWorksheetColumns = (worksheet: any) => {
  const columnWidths = [];
  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  for (let col = range.s.c; col <= range.e.c; col++) {
    let maxWidth = 0;
    for (let row = range.s.r; row <= range.e.r; row++) {
      const cellAddress = XLSX.utils.encode_cell({ c: col, r: row });
      const cell = worksheet[cellAddress];
      if (cell && cell.v) {
        const cellLength = cell.v.toString().length;
        maxWidth = Math.max(maxWidth, cellLength);
      }
    }
    columnWidths.push({ wch: maxWidth + 2 }); // Adding a buffer for padding
  }

  worksheet["!cols"] = columnWidths; // Set the calculated widths

  return worksheet;
};

const autoScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const autoScrollToBottom = () => {
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: "smooth",
  });
};

interface MenuPermissions {
  [menuCode: string]: {
    [tabCode: string]: string[];
  };
}

const checkAccess = (
  menuCode: string,
  tabCode: string,
  permissionToBeChecked: string
): boolean => {
  console.log("checkAccess called", {
    menuCode,
    tabCode,
    permissionToBeChecked,
  });

  try {
    const permissionData = store.getState().user.menu_permission as
      | MenuPermissions
      | false;
    const isSuperUser = store.getState().user?.is_superuser || false;
    const isEmployee = store.getState().user?.isEmployee || false;

    if (isSuperUser || isEmployee) {
      return true;
    }

    if (!permissionData || !menuCode || !tabCode || !permissionToBeChecked) {
      return false;
    }

    const menuPermissions = permissionData[menuCode];
    if (!menuPermissions) {
      return false;
    }

    const tabPermissions =
      menuPermissions[tabCode] || menuPermissions[`default-${menuCode}`];
    return (
      Array.isArray(tabPermissions) &&
      tabPermissions.includes(permissionToBeChecked)
    );
  } catch (error: any) {
    console.error("Error checking access:", error);
    return false;
  }
};

const checkEmployeeAccess = (
  menuCode: string,
  tabCode: string,
  permissionToBeChecked: string
): boolean => {
  console.log("checkEmployeeAccess called", {
    menuCode,
    tabCode,
    permissionToBeChecked,
  });

  try {
    const permissionData = store.getState().user.menu_permission as
      | MenuPermissions
      | false;
    const isSuperUser = store.getState().user?.is_superuser || false;
    const isEmployee = store.getState().user?.isEmployee || false;

    if (isSuperUser) {
      return true;
    }

    if (!permissionData || !menuCode || !tabCode || !permissionToBeChecked) {
      return false;
    }

    const menuPermissions = permissionData[menuCode];
    if (!menuPermissions) {
      return false;
    }

    const tabPermissions =
      menuPermissions[tabCode] || menuPermissions[`default-${menuCode}`];
    return (
      Array.isArray(tabPermissions) &&
      tabPermissions.includes(permissionToBeChecked)
    );
  } catch (error: any) {
    console.error("Error checking access:", error);
    return false;
  }
};

const maskString = (str: any) => {
  str = String(str);
  if (str.length <= 2) return str;
  const firstChar = str.charAt(0);
  const lastChar = str.charAt(str.length - 1);
  const middle = "X".repeat(str.length - 2);
  return firstChar + middle + lastChar;
};

const getTitleWithCompanyName = (title: string): string => {
  let companyName = store.getState().user.defaultCompany || "";

  if (!title) return companyName || "";
  if (!companyName) return title;

  return `${title.trim()} - ${companyName.trim()}`;
};

// This function removes all keys from the data where all values are either 0.00, 0, or empty string
const cleanData = (data: any[]) => {
  if (!data.length) return data;
  const allZeroOrEmptyKeys = Object.keys(data[0]).filter((key) =>
    data.every(
      (item) =>
        item[key] === "0.00" ||
        item[key] === "" ||
        item[key] === "0" ||
        item[key] === 0
    )
  );

  return data.map((item) => {
    const cleanedItem = { ...item };
    allZeroOrEmptyKeys.forEach((key) => delete cleanedItem[key]);
    return cleanedItem;
  });
};

const FormatDateDDMMYYYY = (date: string | Date) => {
  if (!date) return;
  return moment(date).format("DD-MM-YYYY");
};

const cleanPayrunInProcessData = (data: any) => {
  const result: { [key: string]: any[] } = {};

  for (const date in data) {
    result[date] = [
      ...(data[date].pending || []),
      ...(data[date].payrun_in_process?.flatMap(
        (process: any) => process.payslips
      ) || []),
    ];
  }

  return result;
};

export const LIGHT_COLOR_CODES = [
  "#FFE4E1", // Misty Rose
  "#E6E6FA", // Lavender
  "#F0FFF0", // Honeydew
  "#F0FFFF", // Azure
  "#FFF0F5", // Lavender Blush
  "#F0F8FF", // Alice Blue
  "#F5F5DC", // Beige
  "#FAFAD2", // Light Goldenrod Yellow
  "#E0FFFF", // Light Cyan
  "#FFE4B5", // Moccasin
  "#FFE4C4", // Bisque
  "#E6F3FF", // Light Sky Blue
  "#F5FFFA", // Mint Cream
  "#FFF5EE", // Seashell
  "#F8F8FF", // Ghost White
];

export const convertBlobToFile = (
  blobString: string,
  filename?: string
): File | null => {
  if (!blobString) return null;

  try {
    // If it's a base64 string, convert it
    if (blobString.startsWith("data:")) {
      const arr = blobString.split(",");
      const mime = arr[0].match(/:(.*?);/)?.[1] || "application/octet-stream";
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename || "document", { type: mime });
    }

    // If it's a URL, you'll need to fetch it first
    // This would need to be done asynchronously
    return null;
  } catch (error) {
    console.error("Error converting blob to file:", error);
    return null;
  }
};
  
const getPayrunTimeDescription = (
  currentPayrunDate: string,
  payrunDate: string
): string => {
  console.log("getPayrunTimeDescription called", {
    currentPayrunDate,
    payrunDate,
  });
  
  if (!currentPayrunDate || !payrunDate) {
    return "";
  }

  const current = moment(currentPayrunDate);
  const payrun = moment(payrunDate);

  // Calculate the difference in months
  const diffInMonths = current.diff(payrun, "months");

  // Get month/year for display
  const monthYear = payrun.format("MMMM YYYY");

  if (diffInMonths === 0) {
    return `Current Month (${monthYear})`;
  } else if (diffInMonths === 1) {
    return `Last Month (${monthYear})`;
  } else if (diffInMonths > 1) {
    return `${diffInMonths} Months ago (${monthYear})`;
  } else if (diffInMonths === -1) {
    return `Next Month (${monthYear})`;
  } else {
    const monthsAhead = Math.abs(diffInMonths);
    return `${monthsAhead} Months ahead (${monthYear})`;
  }
};

const formatToTwoDecimals = (val: string | number): number => {
  // Handle null, undefined, or empty string cases
  if (val === null || val === undefined || val === '') {
    return 0;
  }
  
  // Convert string to number, handling cases with commas or dollar signs
  const cleanVal = typeof val === 'string' ? val.replace(/[$,]/g, '') : val;
  const num = parseFloat(cleanVal.toString());
  
  // Return 0 for invalid numbers
  if (isNaN(num) || !isFinite(num)) {
    return 0;
  }
  
  // Round to 2 decimal places and return as number
  return Number(num.toFixed(2));
};

const getDaysCount = (startDate: string, endDate: string): number => {
  const start = moment(startDate);
  const end = moment(endDate);
  // Add 1 to include both start and end dates in the count
  return end.diff(start, 'days') + 1;
};

const employeeColors = [
  "#FF6B6B", "#FF9F1C", "#6BCB77", "#4D96FF", "#C77DFF",
  "#E63946", "#F3722C", "#43AA8B", "#577590", "#9D4EDD",
  "#FF006E", "#8338EC", "#3A86FF", "#06D6A0", "#FFD60A",
  "#EF476F", "#118AB2", "#073B4C", "#F94144", "#90BE6D",
  "#277DA1", "#F9844A", "#F9C74F", "#43AA8B", "#577590",
  "#7209B7", "#3F37C9", "#4895EF", "#4361EE", "#4CC9F0",
  "#E36414", "#9A031E", "#5F0F40", "#7B2CBF", "#5A189A",
  "#00B4D8", "#0077B6", "#0096C7", "#023E8A", "#03045E",
  "#2A9D8F", "#264653", "#F77F00", "#E85D04", "#DC2F02",
  "#BC4749", "#6A994E", "#386641", "#1B4332", "#081C15"
];

const formatDateforNotification = (dateString: string) => {
        const date = new Date(dateString);
        const now = new Date();
        const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));

        if (diffInHours < 1) {
            const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
            return `${diffInMinutes}m ago`;
        } else if (diffInHours < 24) {
            return `${diffInHours}h ago`;
        } else {
            const diffInDays = Math.floor(diffInHours / 24);
            return `${diffInDays}d ago`;
        }
    };


// ─── Annual Bonus: SDL / CPF calculation helpers ──────────────────────────────

export const calculateSDL = (basicSalary: number, bonusAmount: number, sdlData: any[]): number => {
  if (!sdlData || sdlData.length === 0) return 0;
  // const grossSalary = basicSalary + bonusAmount;
  const grossSalary = bonusAmount;
  if (!bonusAmount) return 0;
  const entry = sdlData.find((e: any) => {
    const min = parseFloat(e.min_amount);
    const max = parseFloat(e.max_amount);
    return grossSalary >= min && grossSalary <= max;
  });
  if (!entry) return 0;
  let sdlValue = grossSalary * (parseFloat(entry.percentage) / 100);
  const minSdl = parseFloat(entry.min_sdl);
  const maxSdl = parseFloat(entry.max_sdl);
  if (sdlValue > maxSdl) sdlValue = maxSdl;
  if (sdlValue < minSdl) sdlValue = minSdl;
  return Math.round(sdlValue * 100) / 100;
};

// Replaces all "N% (expr)" terms with "(N/100 * (expr))", correctly handling nested parentheses.
export const replacePercentTerms = (expr: string): string => {
  let out = "";
  let lastIndex = 0;
  const re = /(\d+\.?\d*)\s*%\s*\(/g;
  let match: RegExpExecArray | null;
  while ((match = re.exec(expr)) !== null) {
    const pct = parseFloat(match[1]) / 100;
    const openPos = match.index + match[0].length - 1;
    let depth = 1;
    let j = openPos + 1;
    while (j < expr.length && depth > 0) {
      if (expr[j] === "(") depth++;
      else if (expr[j] === ")") depth--;
      j++;
    }
    const inner = expr.slice(openPos + 1, j - 1);
    out += expr.slice(lastIndex, match.index) + `(${pct} * (${inner}))`;
    lastIndex = j;
    re.lastIndex = j;
  }
  return out + expr.slice(lastIndex);
};

export const evaluateCPFFormula = (formula: string, ow: number, aw: number): number => {
  if (!formula) return 0;
  let expr = formula.split(",")[0].trim();
  const cap = formula.split(",")[1]?.trim();
  if (expr === "0") return 0;
  const tw = ow + aw;
  expr = expr.replace(/\$(\d+\.?\d*)/g, "$1");
  expr = replacePercentTerms(expr);
  try {
    const result = Parser.evaluate(expr, { OW: ow, AW: aw, TW: tw });
    // if (cap) {
    //   const capValue = Number(cap.replace(/\$/g, ""));
    //   return isFinite(result) ? Math.min(Number(result.toFixed(2)), capValue) : 0;
    // }
    return isFinite(result) ? Number(result.toFixed(2)) : 0;
  } catch {
    return 0;
  }
};

export const calculateCPFValues = (
  basicSalary: number,
  bonusAmount: number,
  cpfData: any[]
): { cpfEmployee: number; cpfEmployer: number; cpfTotal: number } => {
  if (!cpfData || cpfData.length === 0)
    return { cpfEmployee: 0, cpfEmployer: 0, cpfTotal: 0 };
  // const grossSalary = basicSalary + bonusAmount;
  const grossSalary = bonusAmount;
  const entry = cpfData.find((e: any) => {
    const min = parseFloat(e.salary_min);
    const max = parseFloat(e.salary_max);
    return grossSalary >= min && grossSalary <= max;
  });
  if (!entry) return { cpfEmployee: 0, cpfEmployer: 0, cpfTotal: 0 };
  const cpfTotal = evaluateCPFFormula(entry.total_cpf, 0, bonusAmount);
  const cpfEmployee = evaluateCPFFormula(entry.employee_cpf, 0, bonusAmount);
  const cpfEmployer = Math.round((cpfTotal - cpfEmployee) * 100) / 100;
  return { cpfEmployee, cpfEmployer, cpfTotal };
};

// ─────────────────────────────────────────────────────────────────────────────

export const Utils = {
  LIGHT_COLOR_CODES,
  formatTimestamp,
  getFormatedDate,
  resetStoreData,
  validateEmail,
  getEmployeeName,
  getNumberWithCommas,
  getPriceFromString,
  isNumberWithComma,
  getDate,
  _date,
  sortString,
  convertToDateString,
  monthsPassed,
  isEmpty,
  formateStringWithUnderscore,
  generateYearArray,
  monthNameNumberMap,
  prependDollar,
  generateYearArrayTillNow,
  MONTH_FULL_NAMES,
  _dateToShow,
  _timeToShow,
  MONTH_OPTIONS,
  getLastDayOfMonth,
  addDecimalAndZeroes,
  getPreviousMonthYear,
  getNextMonthYear,
  getMonthRange,
  dayMonthNameFormat,
  removeDuplicates,
  differenceInDays,
  getDefaultYearRange,
  getCommanSepartedNumericStringWithDollar,
  getCommanSepartedNumericString,
  getStartDateOfMonth,
  getLastDateOfMonth,
  validateNetPay,
  showErrorMessage,
  getFirstDayOfPreviousMonth,
  getLastDayOfPreviousMonth,
  autoFitWorksheetColumns,
  autoScrollToTop,
  getMonthNameWithYear,
  checkAccess,
  maskString,
  getTitleWithCompanyName,
  cleanData,
  FormatDateDDMMYYYY,
  cleanPayrunInProcessData,
  checkEmployeeAccess,
  convertBlobToFile,
  getPayrunTimeDescription,
  formatToTwoDecimals,
  getDaysCount,
  autoScrollToBottom,
  getFirstDayOfTheMonth,
  getLastDayOfTheMonth,
  employeeColors,
  formatDateforNotification,
};
